import { z } from "zod";

/** Teto da imagem da capa: o navegador reduz pra 1600px antes de mandar. */
export const MAX_CAPA_DO_CATALOGO = 900_000;

const texto = (max: number) => z.string().trim().max(max);

/**
 * A aparência do catálogo do laboratório (PDF e link público): cor de destaque, fundo, capa,
 * contatos do rodapé e o que mostrar. Do plano com `customization`; sem ele vale a padrão.
 */
export const aparenciaDoCatalogoSchema = z.object({
  /** Cor de destaque; nulo = o preto de sempre. */
  cor: z.string().regex(/^#[0-9a-f]{6}$/i).nullable(),
  /** claro = a cor bem suave atrás da lista; marcaDagua = o logo bem suave. */
  fundo: z.enum(["branco", "claro", "marcaDagua"]),
  capa: z.object({
    ativa: z.boolean(),
    titulo: texto(60),
    texto: texto(400),
    /** Fundo da capa: a cor de destaque ou a imagem enviada. */
    estilo: z.enum(["cor", "imagem"]),
  }),
  contatos: z.object({ whatsapp: texto(40), instagram: texto(60), site: texto(80), email: texto(80) }),
  rodapeTexto: texto(200),
  mostrar: z.object({ cnpj: z.boolean(), endereco: z.boolean(), fotos: z.boolean(), descricoes: z.boolean() }),
});
export type AparenciaDoCatalogo = z.infer<typeof aparenciaDoCatalogoSchema>;

/** O visual de antes da personalização: quem não mexe (ou não tem o plano) vê exatamente isso. */
export const APARENCIA_PADRAO: AparenciaDoCatalogo = {
  cor: null,
  fundo: "branco",
  capa: { ativa: false, titulo: "", texto: "", estilo: "cor" },
  contatos: { whatsapp: "", instagram: "", site: "", email: "" },
  rodapeTexto: "",
  mostrar: { cnpj: true, endereco: true, fotos: true, descricoes: true },
};

/** Aparência guardada no banco (JSON) lida com segurança: o que não valida vira a padrão. */
export function lerAparenciaDoCatalogo(valor: unknown): AparenciaDoCatalogo {
  return aparenciaDoCatalogoSchema.safeParse(valor).data ?? APARENCIA_PADRAO;
}

export const salvarAparenciaDoCatalogoSchema = z.object({
  aparencia: aparenciaDoCatalogoSchema,
  /** Imagem da capa: data URL troca, null apaga, ausente não mexe. */
  capa: z
    .string()
    .regex(/^data:image\/(jpeg|png|webp);base64,/, "Formato de imagem não aceito.")
    .max(MAX_CAPA_DO_CATALOGO, "Imagem muito grande.")
    .nullable()
    .optional(),
});
export type SalvarAparenciaDoCatalogoInput = z.infer<typeof salvarAparenciaDoCatalogoSchema>;
